import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'
import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'
import Input from '../../form/Input'

const PresentationSettingsModal = ({ store }) => (
    <Modal
        show={store.globalSettingsModalOpen}
        onClose={store.handleCloseGlobalSettingsModal}
    >
        <Typography type="h3">{i18n.t('powerpoint.modals.global.title')}</Typography>

        <Typography type="tiny">{i18n.t('powerpoint.modals.global.description')}</Typography>

        <br />

        <hr />

        <br />

        <Input
            label={i18n.t('presentation.globalSettings.presentationTitle')}
            defaultValue={store.presentationTitle}
            onBlur={store.handlePresentationTitleChange}
        />

        {!store.isGESurvey && (
            <>
                <div style={{
                    display: 'flex', gap: 20, marginTop: 20, justifyContent: 'space-between',
                }}
                >
                    <div
                        style={{ display: 'flex', flexDirection: 'column', width: '50%' }}
                    >
                        <Typography type="b">{i18n.t('presentation.globalSettings.selectBenchmarks')}</Typography>

                        <div style={{
                            display: 'flex', flexDirection: 'column', gap: 5, marginTop: 10,
                        }}
                        >
                            {store.globalBenchmarks.map((bm) => (
                                <Checkbox
                                    label={bm.label}
                                    value={bm.value}
                                    name={bm.value}
                                    checked={bm.checked}
                                    onBlur={store.handleToggleGlobalBenchmark}
                                />
                            ))}
                        </div>
                    </div>

                    <div style={{
                        width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                    }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography type="b">{i18n.t('presentation.globalSettings.comparisonYears')}</Typography>

                            <div style={{
                                display: 'flex', flexDirection: 'column', gap: 5, marginTop: 10,
                            }}
                            >
                                {Object.keys(store.presentationComparisonYears).map((year) => (
                                    <Checkbox
                                        label={year}
                                        value={year}
                                        name={year}
                                        checked={store.presentationComparisonYears[year]}
                                        onBlur={store.handleToggleGlobalYear}
                                    />
                                ))}
                            </div>
                        </div>

                        <br />

                        <Select
                            label={i18n.t('presentation.globalSettings.benchmarkPeriod')}
                            options={store.benchmarkPeriods}
                            value={store.benchmarkPeriods.find((p) => p.value === store.benchmarkPeriod)}
                            onBlur={store.updateGlobalBenchmark}
                        />
                    </div>
                </div>

                <br />
            </>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
            <Button
                label={i18n.t('save')}
                icon="fal fa-save"
                onClick={store.handleCloseGlobalSettingsModal}
                cssClass="regular primary"
            />
        </div>
    </Modal>
)

export default observer(PresentationSettingsModal)
